<p>
    Red Tie Runner is a simplistic, yet challenging, reflex-based, 2D
    platforming game. Play as a stickman with a red tie to dash and jump your
    way through obstacles. Features 30 intense levels, including 6 challenge
    levels, accompanied by spikes, trampolines, ziplines, wingsuits, lava, and
    more.
</p>

<p>
    This is the first game I ever finished; back in 2013. Originally it was
    released on the App Store, then passed Steam greenlight. I polished it a bit
    and released it for free. To date, it's received nearly 2 million plays on
    the Scirra Arcade. I also built a version with integrated achievements and leaderboards for Y8.com.
</p>
